import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const LicenseIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M8.5 18H6.5C4.84315 18 3.5 16.6569 3.5 15V5C3.5 3.34315 4.84315 2 6.5 2H13.5C15.1569 2 16.5 3.34315 16.5 5V7.5M11.5 12.25L12.6584 11.6708C13.5029 11.2485 14.4971 11.2485 15.3416 11.6708L16.5 12.25C16.5 12.25 16.5 14.075 16.5 15.0375C16.5 16 15.6103 16.6497 14 17.6667C12.3897 16.6497 11.5 15.7917 11.5 15.0375V12.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

LicenseIcon.displayName = 'LicenseIcon';
